import { createTheme, PaletteMode } from '@mui/material';
import { Themes } from 'routes/Profile/Profile';

export function getTheme(mode: PaletteMode) {
  return createTheme({
    palette: {
      mode,
      primary: {
        main: mode === Themes.DARK ? '#8C57FF' : '#8b57ff',
        light: '#8b57ff',
        dark: '#8C57FF',
      },
      secondary: {
        main: '#8A8D93',
        light: '#A1A4A9',
        dark: '#7C7F84',
        contrastText: '#fff',
      },
      error: {
        main: '#FF4C51',
        light: '#FF7074',
        dark: '#E64449',
        contrastText: '#fff',
      },
      warning: {
        main: '#d49808',
        light: '#d49808',
        dark: '#E6A200',
        contrastText: '#fff',
      },
      info: {
        main: '#16B1FF',
        light: '#45C1FF',
        dark: '#149FE6',
        contrastText: '#fff',
      },
      success: {
        main: '#3c6121',
        light: '#3c6121',
        dark: '#3c6121',
        contrastText: '#fff',
      },
      background: {
        default: mode === Themes.DARK ? '#28243d' : '#f4f5fb',
        paper: mode === Themes.DARK ? '#10102b' : '#FFFFFF',
      },
    },
    shape: {
      borderRadius: 5,
    },
    typography: {
      fontFamily: 'Inter, sans-serif',
      button: {
        textTransform: 'none',
      },
    },
  });
}
